export default "__VITE_ASSET__6LW_Moq$__"